import React, { useEffect, useState, useMemo, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState, AppDispatch } from "../../../redux/store";
import { getCubes } from "../../../redux/queryMetaSlice";
import { Dropdown } from "../../../components/dropdown/Dropdown";
import {
  Cube,
  setSelectedCube,
  setCubesMap,
} from "../../../redux/queryMetaSlice";
import { showNotification } from "../../../redux/notificationSlice";

const QueryCubes = ({ currentActiveTab }: { currentActiveTab: number }) => {
  // const currentActiveTab = useSelector((state:any) => state.queryBuilder.currentTabIndex);
  const metaState = useSelector(
    (state: any) => state.meta.metaStates[currentActiveTab],
  );

  const [selectedCategoryGroup, setSelectedCategoryGroup] =
    useState<string>("");

  // Track whether the user has explicitly made a selection to prevent
  // useEffect([cubesMap]) from resetting the category group after selection
  const userSelectedRef = useRef(false);

  const selectedCube = useSelector(
    (state: any) => state.meta.metaStates[currentActiveTab].selectedCube,
  );

  const dispatch = useDispatch<AppDispatch>();
  const { meta } = useSelector((state: RootState) => state.meta);
  const error = metaState.error;

  useEffect(() => {
    if (selectedCube === null && !meta) {
      dispatch(getCubes(currentActiveTab));
    }
  }, [dispatch, selectedCube, meta]);
  //type CategoryListMap = Map<string, Cube[]>;
  const cubesMap: Map<string, Cube[]> = useMemo(() => {
    const map = new Map();
    if (meta || selectedCube === null) {
      meta?.forEach((item) => {
        item.catalogs.forEach((catalog) => {
          catalog.schemas.forEach((schema) => {
            schema.cubes.forEach((cube) => {
              map.set(cube.annotations.categoryGroup, [
                ...(map.get(cube.annotations.categoryGroup) || []),
                cube,
              ]);
            });
          });
        });
      });
    }
    return map;
  }, [meta, currentActiveTab, selectedCube]); // removed selectedCube — caused cubesMap to recompute on every cube selection

  useEffect(() => {
    if (cubesMap.size > 0) {
      dispatch(setCubesMap({ cubesMap: Object.fromEntries(cubesMap) as any }));
    }
  }, [cubesMap]);
  useEffect(() => {
    const defCategoryGroup = Array.from(cubesMap.keys())[0];

    if (selectedCube !== null && cubesMap.size > 0) {
      for (const [group, cubes] of cubesMap.entries()) {
        if (cubes.some((cube) => cube.name === selectedCube.name)) {
          setSelectedCategoryGroup(group);
          break;
        }
      }
      return;
    }

    if (!userSelectedRef.current) {
      setSelectedCategoryGroup(defCategoryGroup);
    }
    const groupToUse = selectedCategoryGroup || defCategoryGroup;
    const selectedCubeTemp = cubesMap.get(groupToUse);
    if (
      selectedCube === null &&
      selectedCubeTemp &&
      selectedCubeTemp.length >= 1
    ) {
      dispatch(
        setSelectedCube({
          selectedCube: selectedCubeTemp[0],
          currentActiveTab,
        }),
      );
    }
  }, [cubesMap, selectedCube]);

  const handleCategoryGroup = (newValue: string) => {
    userSelectedRef.current = true;
    setSelectedCategoryGroup(newValue);
    // Auto-select first cube in the new category
    const firstCube = cubesMap.get(newValue)?.[0];
    if (firstCube) {
      dispatch(setSelectedCube({ selectedCube: firstCube, currentActiveTab }));
    }
  };

  const handleSelectedGroup = (newValue: string) => {
    userSelectedRef.current = true;
    const selectedCube = cubesMap
      .get(selectedCategoryGroup)
      ?.find((cube) => cube.caption === newValue);
    if (selectedCube) {
      dispatch(setSelectedCube({ selectedCube, currentActiveTab }));
    }
  };

  useEffect(() => {
    if (error) {
      dispatch(
        showNotification({ message: error, duration: 6000, isError: true }),
      );
    }
  }, [error]);

  return (
    <div className="cubes-section">
      <div className="cubes-header">Cubes</div>
      <div className="cubes-list">
        {/* {cubesMap.size > 1 && 
        <Dropdown id={"category-dropdown"} selectedValue={selectedCategoryGroup} onChange={handleCategoryGroup}
        options={Array.from(cubesMap.keys()).map(key => ({ label: key, value: key }))}/>\r\n        } */}
        <Dropdown
          id={"category-dropdown"}
          selectedValue={selectedCategoryGroup}
          onChange={handleCategoryGroup}
          options={Array.from(cubesMap.keys()).map((key) => ({
            label: key,
            value: key,
          }))}
        />
        <Dropdown
          id={"cube-dropdown"}
          selectedValue={selectedCube?.caption || ""}
          onChange={handleSelectedGroup}
          options={
            cubesMap
              .get(selectedCategoryGroup)
              ?.map((cube) => ({ label: cube.caption, value: cube.caption })) ||
            []
          }
        />
      </div>
    </div>
  );
};

export default QueryCubes;
